require('slick-carousel')

$(()=> {
  let sliderCategory = $('.faq-category');
  let media800 = window.matchMedia('(max-width: 801px)');

  if (media800.matches) {
    sliderCategory.slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      infinite: false

    });
  }

  // ACORDERON
  $('.accordion').on('click', '.head', function (e) {
    let el = $(this);
    let h = el.next();

    if (el.hasClass('active')) {
      el.removeClass('active');
    } else {
      el.addClass('active');
    }
    h.slideToggle();
  });

})
